"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APPOINTMENT_TO_FHIR_MAPPING = void 0;
exports.APPOINTMENT_TO_FHIR_MAPPING = [
    // AppointmentDto -> FHIR Appointment
    { sourceDto: 'AppointmentDto', dtoField: 'id', fhirPath: 'id' },
    {
        sourceDto: 'AppointmentDto',
        dtoField: 'status',
        fhirPath: 'status',
        notes: "NEXAO's 6-value status has no exact FHIR AppointmentStatus equivalent — PENDING_CONFIRMATION -> 'pending', CONFIRMED -> 'booked', CHECKED_IN -> 'arrived', COMPLETED -> 'fulfilled', CANCELLED -> 'cancelled', NO_SHOW -> 'noshow'. A lookup table, not a 1:1 enum match.",
    },
    { sourceDto: 'AppointmentDto', dtoField: 'scheduledAt', fhirPath: 'start' },
    {
        sourceDto: 'AppointmentDto',
        dtoField: 'durationMinutes',
        fhirPath: '(derived) end',
        notes: 'FHIR Appointment has no durationMinutes field directly — `end` is computed as `start + durationMinutes`, the same relationship this DTO itself represents as two fields instead of one interval.',
    },
    {
        sourceDto: 'AppointmentDto',
        dtoField: 'consultationMode',
        fhirPath: 'appointmentType / participant[?actor=Location].actor.extension["virtual-service"]',
        notes: 'TELEMEDICINE maps to a virtual-service-flagged participant per FHIR R4\'s telehealth pattern; no single flat field carries this.',
    },
    { sourceDto: 'AppointmentDto', dtoField: 'patientId', fhirPath: 'participant[?actor=Patient].actor.reference', notes: 'References Patient Identity\'s own PatientDto -> FHIR Patient mapping (fhir-mapping.types.ts) — not remapped here.' },
    { sourceDto: 'AppointmentDto', dtoField: 'doctorId', fhirPath: 'participant[?actor=Practitioner].actor.reference', notes: 'Practitioner resource itself is out of this bounded context (Platform Engine\'s User) — reference-only mapping.' },
    { sourceDto: 'AppointmentDto', dtoField: 'branchId', fhirPath: 'participant[?actor=Location].actor.reference', notes: 'Location resource itself is out of this bounded context (Platform Engine\'s Branch) — reference-only mapping.' },
    {
        sourceDto: 'AppointmentDto',
        dtoField: 'clinicalPurposeId',
        fhirPath: 'serviceType',
        notes: 'Requires a LookupValue -> FHIR ServiceType code-set translation table, not built yet (same open item Patient Identity\'s own genderId mapping names).',
    },
    { sourceDto: 'AppointmentDto', dtoField: 'priorityTier', fhirPath: 'priority', notes: 'FHIR priority is an unbounded positive integer (lower = more urgent); NEXAO\'s tier is higher-is-more-urgent — inverted, not a direct copy.' },
    // DoctorScheduleDto -> FHIR Schedule
    { sourceDto: 'DoctorScheduleDto', dtoField: 'id', fhirPath: 'id' },
    { sourceDto: 'DoctorScheduleDto', dtoField: 'doctorId', fhirPath: 'actor[?type=Practitioner].reference' },
    { sourceDto: 'DoctorScheduleDto', dtoField: 'branchId', fhirPath: 'actor[?type=Location].reference' },
    { sourceDto: 'DoctorScheduleDto', dtoField: 'effectiveFrom', fhirPath: 'planningHorizon.start' },
    { sourceDto: 'DoctorScheduleDto', dtoField: 'effectiveTo', fhirPath: 'planningHorizon.end' },
    {
        sourceDto: 'DoctorScheduleDto',
        dtoField: 'isActive',
        fhirPath: 'active',
        notes: 'DoctorSession (this schema\'s own child table, not yet its own DTO/contract) is what FHIR Schedule\'s comment field / the paired Slot resources would actually derive their recurrence from — not mapped further here.',
    },
    // AvailableSlotDto / AppointmentSlotHoldDto -> FHIR Slot
    { sourceDto: 'AvailableSlotDto', dtoField: 'scheduledAt', fhirPath: 'start' },
    { sourceDto: 'AvailableSlotDto', dtoField: 'durationMinutes', fhirPath: '(derived) end' },
    {
        sourceDto: 'AvailableSlotDto',
        dtoField: 'sessionCategory',
        fhirPath: 'serviceType',
        notes: 'Same LookupValue/code-set translation gap as AppointmentDto.clinicalPurposeId.',
    },
    {
        sourceDto: 'AppointmentSlotHoldDto',
        dtoField: 'scheduledAt',
        fhirPath: 'start',
        notes: 'A `AppointmentSlotHold` is FHIR Slot with status "busy-tentative" — an ephemeral reservation, never persisted as its own FHIR resource instance in NEXAO\'s own design (ADR-023).',
    },
];
//# sourceMappingURL=appointment-fhir-mapping.types.js.map